import React, { useEffect, useRef } from 'react'
import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import { motion } from 'framer-motion';
import { fontLink, fullCenter } from '../../base';

function Motion(props) {
    const { scale, stiffness, damping, dontHover } = props;

    const clonedComp = React.cloneElement(props.children, {
        component: motion.div,
        whileHover: { scale: scale || (dontHover ? 1 : 1.08) },
        transition: {
            type: "spring",
            stiffness: stiffness || 150,
            damping: damping || 10,
        },
    });

    return <>{clonedComp}</>;
}

export default function CountrySlider({ sxContainer = {}, sxBox = {}, flags,
    chunkSizes = [5, 5, 6, 6, 6]
}) {
    const ref = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {

        const handleScroll = () => {
            if (!ref.current || !containerRef.current) return;

            const rect = ref.current.getBoundingClientRect();
            const scrollOffset = Math.max(0, window.innerHeight - rect.top);
            const MAX_SCROLL_DOWN = 1200;
            const SPEED = 3;
            const margin = Math.min(MAX_SCROLL_DOWN, scrollOffset) / SPEED;

            containerRef.current.childNodes.forEach((row, i) => {
                if (!row) return;
                if (i % 2 === 0) {
                    row.style.paddingLeft = `${margin}px`;
                    row.style.paddingRight = '';
                } else {
                    row.style.paddingRight = `${margin}px`;
                    row.style.paddingLeft = '';
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        requestAnimationFrame(handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const MIN_LOGOS_PER_LINE = 4;

    const chunkedLogos = chunkLogos(chunkSizes);
    const minLineHeight = 66;


    function chunkLogos(sizeOrArray = 7) {
        const defaultSize = typeof sizeOrArray === "number" ? sizeOrArray : sizeOrArray[0];
        const chunks = [];
        let startIndex = 0;
        let rowIndex = 0;

        while (startIndex < flags.length) {
            const rowSize =
                Array.isArray(sizeOrArray) && sizeOrArray[rowIndex] != null
                    ? sizeOrArray[rowIndex]
                    : defaultSize;

            const chunk = flags.slice(startIndex, startIndex + rowSize);
            chunks.push(chunk);
            startIndex += rowSize;
            rowIndex++;
        }

        return chunks
            .map((chunk, i) => {
                const len = chunk.length;
                if (len < MIN_LOGOS_PER_LINE) return chunk;
                const first = chunk[0];
                const sec = chunk[1];
                const last = chunk[len - 1];
                const prelast = chunk[len - 2];
                return [prelast, last, ...chunk, first, sec];
            })
            .filter(c => c.length >= MIN_LOGOS_PER_LINE);
    }

    return (
        <div ref={ref}>
            <Container maxWidth="lg" sx={{ px: "0px !important", overflow: 'hidden', ...sxContainer }}>
                <Box sx={{ px: { xs: "16px", sm: "24px", md: "24px", lg: "24px" }, overflow: 'hidden', }}>
                    <Box
                        ref={containerRef}
                        sx={{
                            position: 'relative',
                            pt: `60px`,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            alignContent: "center",
                            mx: '-80px',
                            WebkitMaskImage: "linear-gradient(to right, transparent, black 5%, black 95%, transparent)",
                            maskImage: "linear-gradient(to right, transparent, black 5%, black 95%, transparent)",
                            ...sxBox,
                        }}
                    >
                        <Box sx={{ position: 'absolute', top: 0, height: `100%`, width: '100vw' }} />
                        {chunkedLogos.map((logos, i) =>
                            <Box
                                key={"ChunkMain" + i}
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    alignContent: "center",
                                    gap: { xs: '12px', sm: "16px" },
                                    WebkitMaskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
                                    maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
                                    pb: i === chunkedLogos.length - 1 ? '0px' : { xs: '12px', sm: '24px' },
                                }}
                            >
                                {logos.map((d, y) =>
                                    <Motion key={"CSlideM" + i + y} scale={1.02}>
                                        <Box key={"CSlideBox" + i + y} sx={{ borderRadius: '50px', bgcolor: 'white', ...fullCenter, flexDirection: 'row', height: '38px', px: '10px', py: '5px' }}>
                                            <Box component={'img'} sx={{ width: '24px', height: '24px' }} src={d.flag} />
                                            <Typography sx={{
                                                "fontFamily": "Inter", fontWeight: 500,
                                                ...fontLink, lineHeight: '16px', "verticalAlign": "middle", color: 'black', pl: '6px', textAlign: 'left', pr: '3px'
                                            }}>{d.text}</Typography>
                                        </Box>
                                    </Motion>
                                )}

                            </Box>
                        )}
                    </Box>
                </Box>
            </Container>
        </div>
    )
}
